import { gql, TypedDocumentNode } from "@apollo/client";

import {
  MarkNotificationReadMutation,
  MarkNotificationReadMutationVariables,
} from "./MarkNotificationRead.generated";

export const MARK_NOTIFICATION_READ: TypedDocumentNode<
  MarkNotificationReadMutation,
  MarkNotificationReadMutationVariables
> = gql`
  mutation markNotificationRead($notificationUuid: String!) {
    markNotificationRead(notificationUuid: $notificationUuid) {
      ok
    }
  }
`;
